<footer class="footer-bar">Copyright © 2026 CBRE. All rights reserved.</footer>
